/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Translation from '../translation/translation';
import { onOpenMotoTyreSizeConfiguratorClick } from '../../../_views/configurator_buttons/configurator_buttons';

function MotoTyreSizeConfiguratorButton(props) {
  function handleAction(e) {
    e.preventDefault();
    onOpenMotoTyreSizeConfiguratorClick(true);
  }

  return (
    <div className="configurator-alternative" onClick={(e) => handleAction(e)}>
      <div className="icon icon--moto-tyre-size"></div>
      <Translation
        translationKey={'configurator-button-search-by-moto-tyre-size'}
        className="configurator-size-moto"
        tagName="div"
      />
    </div>
  );
}

export default MotoTyreSizeConfiguratorButton;
